(function () {
	const calcMinHeight = (root) => {
		if (!root) return;
		const sectionEl = root.closest("[id^='shopify-section-']") || root;
		const sharedToolbar = sectionEl.querySelector("[data-clist-shared-toolbar]");
		const productsFacetsHost = sectionEl.querySelector("[data-clist-products-facets]");
		const collectionsFacetsHost = sectionEl.querySelector("[data-clist-collections-facets]");
		const toolbarHost = sharedToolbar || productsFacetsHost || collectionsFacetsHost || root;
		const sortWrapper = toolbarHost.querySelector(
			".facets__top .facets__sort-wrapper, .facets__top .clist-toolbar-row, .clist-toolbar-row, .facets__top.clist-toolbar-grid, .clist-toolbar-grid"
		);
		const collectionWrapper = root.querySelector(".collection-wrapper");

		if (sortWrapper && collectionWrapper) {
			if (sharedToolbar) {
				collectionWrapper.style.paddingTop = "";
				collectionWrapper.style.gridTemplateRows = "";
				return;
			}
			const toolbarHeight = sortWrapper.getBoundingClientRect().height;
			if (sectionEl.querySelector("[data-clist-collections-grid]")) {
				collectionWrapper.style.paddingTop = toolbarHeight + "px";
				collectionWrapper.style.gridTemplateRows = "";
			} else {
				collectionWrapper.style.paddingTop = "";
				collectionWrapper.style.gridTemplateRows = toolbarHeight + "px auto 1fr";
			}
		}
	};

	const resizeCollectionGrid = () => {
		const roots = document.querySelectorAll(
			".collection-grid-section, .section-search"
		);
		const observerHosts = document.querySelectorAll("[data-collection-list-grid-observer]");
		const allRoots = roots.length || observerHosts.length
			? [...roots, ...observerHosts]
			: [];
		if (!allRoots.length) return;

		allRoots.forEach((collectionGridSection) => {
			const sectionResizeObserver = new ResizeObserver(() => {
				calcMinHeight(collectionGridSection);
			});
			sectionResizeObserver.observe(collectionGridSection);
			calcMinHeight(collectionGridSection);
		});
	};

	document.addEventListener("shopify:section:load", function () {
		resizeCollectionGrid();
	});
	resizeCollectionGrid();
})();
